export const ROLES = {
  farmer: "farmer",
  supervisor: "supervisor",
  admin: "admin",
};
